import * as Sentry from '@sentry/react';

export function initSentry(dsn: string) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Never include request/response bodies — mail subjects and content must not leak.
    sendDefaultPii: false,
    maxBreadcrumbs: 20,
    beforeSend(event) {
      // Drop breadcrumb data payloads (may contain API response bodies with mail content).
      if (event.breadcrumbs) {
        for (const crumb of event.breadcrumbs) {
          if (crumb.data) {
            delete (crumb.data as Record<string, unknown>)['body'];
            delete (crumb.data as Record<string, unknown>)['response'];
          }
        }
      }
      return event;
    },
  });
}

export { Sentry };
